import { render, staticRenderFns } from "./VAppHeader.vue?vue&type=template&id=cc22691a&"
import script from "./VAppHeader.vue?vue&type=script&lang=ts&"
export * from "./VAppHeader.vue?vue&type=script&lang=ts&"
import style0 from "./VAppHeader.vue?vue&type=style&index=0&id=cc22691a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports